/**
 * Event data sender
 */

import Network from '../../utils/network';
import {loader} from '../../utils/loader';
import Modal from '../../common/modal';
import Update from './update';

class Sender {
    static SAVE_LINK = 'index.php?route=checkout/cart/add';

    /**
     * Save data
     * @param {Object} data
     */
    static save(data) {
        Network.call({
            link: this.SAVE_LINK,
            method: 'POST',
            data,
        }).then(async (r) => {
            let {success, html = '', cart = ''} = r;

            if (success === undefined) {
                throw new SyntaxError('No status indicated. Status is required in the response.');
            }

            Modal.run({content: html});
            Update.run(cart);
        }).catch((reason) => {
            throw new SyntaxError(`Can't send. Reason: ${reason}`);
        }).finally(() => {
            loader(false);
        });
    }
}

export default Sender;
